import api from '../api/api'
import Constant from '../constant'
import axios from 'axios'
import router from '../router/index'

export default {
  // 로그인
  [Constant.LOGIN]: (store, payload) => {
    console.log('## 31 ' + payload.id)
    api.login(payload.id, payload.password)
      .then((response) => {
        console.log('## 32 ' + 'done')
        if (response.data.status === 'success') {
          console.log('## 35 ' + 'success')
          console.log('## 44 ' + response.data.status);

          console.log('## 3 ' + JSON.stringify(response.data));

          store.commit(Constant.LOGIN, {access_token: response.data.access_token ,user_name:response.data.user_name })

          console.log('## 35 ' + 'xx')

          axios.defaults.headers.common['authorization'] = response.data.access_token

        } else if(response.data.status === 'logout') {
          alert('에러 : ' + response.data.message)
          api.goLogin()
        } else {
          console.log('## 3 ' + JSON.stringify(response.data));
          alert('에러 : ' + response.data.message)
        }
      })
  },

  [Constant.LOGOUT]: (store) => {
    // console.log('## 3 ' + payload.password)
    store.commit(Constant.LOGIN, {access_token: ''})
    axios.defaults.headers.common['authorization'] = ''
  },


  [Constant.BOARD_DETAIL]: (store) => {
    // console.log('## 3 ' + payload.password)
    return store.state.board_detail
  },

  [Constant.SET_ACCESS_TOEKN]: (store, payload) => {
    console.log('## setAcessToken 000')
    api.setAcessToken(payload.access_token)
  },

  [Constant.UPDATE_USER_INFO]: (store, payload) => {
    console.log('## UPDATE_USER_INFO :' + payload.password + ' ' + payload.newpassword)

    api.updateUserInfo(payload.password, payload.newpassword, store.state.account)
      .then((response) => {
        if (response.data.status === 'success') {
          // store.dispatch(Constant.ADD_DEVICE);//, {pageno: 1})
          // store.commit(Constant.UPDATE_USER_INFO , { userinfo : response.data.result } )
          // console.log('계정 정보 수정 성공 : ' + response.data)
          alert('계정 정보가 정상적으로 수정 되었습니다.')
        } else if(response.data.status === 'logout') {
          alert('에러 : ' + response.data.message)
          api.goLogin()
        } else {
          alert('에러 : ' + response.data.message)
        }
      })
  },

  [Constant.FETCH_USER_INFO]: (store) => {
    console.log('## action [Constant.FETCH_DEVICE_ONE]:(store) 111')
    api.fetchUserInfo()
      .then((response) => {
        if (response.data.status === 'success') {
          var str = JSON.stringify(response.data)
          console.log('연락처 조회 성공 : ' + str)

          // store.commit( Constant.FETCH_USER_INFO , response.data.result );//, {pageno: 1})
          // console.log('연락처 조회 성공 : ' + response.data)
          store.commit(Constant.FETCH_USER_INFO, {userinfo: response.data.result})
          /*
          var obj = new Object();
          obj.no = response.data.no;
          obj.name = response.data.name;
          obj.serial = response.data.serial;
          //obj.dailysame = response.data.;
          obj.dailysetting = '';
          obj.weeklysettings = '';
          */
        } else if(response.data.status === 'logout') {
          alert('에러 : ' + response.data.message)
          api.goLogin()
        } else {
          alert('에러 : ' + response.data.message)
        }
      })
  },

  [Constant.FETCH_DEVICES]: (store) => {
    console.log('## 4 authorization : ' + axios.defaults.headers.common['authorization'])
    console.log('## 5 authorization : ' + axios.defaults.headers)
    api.fetchDevices()
      .then((response) => {
        if (response.data.status === 'success') {
          console.log('## 3 ' + response.data.status)
          console.log(response.data.result.device_list)

          var result = []
          console.log('## 1 ' + response.data.result.device_list.length)
          for (var i = 0; i < response.data.result.device_list.length; i++) {
            var obj = {}
            obj.no = response.data.result.device_list[i].no
            obj.name = response.data.result.device_list[i].name
            obj.numofcheck = 0
            obj.lastscore = 0
            obj.increase = 0
            obj.isconnected = response.data.result.device_list[i].isconnected
            result.push(obj)
          }
          console.log('## AA' + result)
          store.commit(Constant.FETCH_DEVICES, {devicelist: result})
          // store.commit(constant.FETCH_DEVICES, {:result});
        }else if(response.data.status === 'logout') {
          alert('에러 : ' + response.data.message)
          api.goLogin()
        } else {
          alert('에러 : ' + response.data.message)
        }
      })
  },

  [Constant.FETCH_DEVICE_ONE]: (store, payload) => {
    console.log('## action [Constant.FETCH_DEVICE_ONddE]:(store) ' + payload.no)
    api.fetchDeviceOne(payload.no)
      .then((response) => {
        if (response.data.status === 'success') {
          // store.dispatch(Constant.ADD_DEVICE);//, {pageno: 1})
          console.log('연락처 조회 성공 : ' + response.data)
          store.commit(Constant.FETCH_DEVICE_ONE, response.data.result)
          /*
          var obj = new Object();
          obj.no = response.data.no;
          obj.name = response.data.name;
          obj.serial = response.data.serial;
          //obj.dailysame = response.data.;
          obj.dailysetting = '';
          obj.weeklysettings = '';
          */
        } else if(response.data.status === 'logout') {
          alert('에러 : ' + response.data.message)
          api.goLogin()
        } else {
          alert('에러 : ' + response.data.message)
        }
      })
  },

  [Constant.ADD_DEVICE]: (store) => {
    console.log(store.state.devicesetting)
    api.addDevice(store.state.devicesetting)
      .then((response) => {
        if (response.data.status === 'success') {
          store.dispatch(Constant.ADD_DEVICE) // , {pageno: 1})
        } else if(response.data.status === 'logout') {
          alert('에러 : ' + response.data.message)
          api.goLogin()
        } else {
          alert('에러 : ' + response.data.message)
        }
      })
  },

  [Constant.UPDATE_DEVICE]: (store) => {
    console.log(  store.state.devicesetting )
    api.updateDevice(store.state.devicesetting)
      .then((response) => {
        if (response.data.status === 'success') {
          store.dispatch(Constant.ADD_DEVICE) // , {pageno: 1})
        } else if(response.data.status === 'logout') {
          alert('에러 : ' + response.data.message)
          api.goLogin()
        } else {
          alert('에러 : ' + response.data.message)
        }
      })
  },

  [Constant.DELETE_CONTACT]: (store, payload) => {
    var currentPageNo = store.state.contactlist.pageno
    api.deleteContact(payload.no).then((response) => {
      store.dispatch(Constant.FETCH_CONTACTS, {pageno: currentPageNo})
    })
  },

  [Constant.FIND_PASSWORD]: (store, payload) => {
    api.findPassword(store.state.contact)
      .then((response) => {
        if (response.data.status === 'success') {
          // store.dispatch(Constant.FETCH_CONTACTS,{pageno:1});
          return true
        } else if(response.data.status === 'logout') {
          alert('에러 : ' + response.data.message)
          api.goLogin()
        } else {
          alert('에러 : ' + response.data.message)
        }
      })
  },

  [Constant.INITIALIZE_DEVICE_ONE]: (store) => {
    console.log('## [Constant.INITIALIZE_DEVICE_ONE]: (store) => {')
    store.commit(Constant.INITIALIZE_DEVICE_ONE)
  },

  [Constant.UPDATE_MENU_RANKING]: (store) => {
    console.log('## [Constant.UPDATE_MENU_RANKING]: (store) => {')
    // store.commit(Constant.INITIALIZE_DEVICE_ONE)
    // 조회 기간으로 시작일과 종료 일을 만들어야 한다.
    var selectedMenu = []
    for (var i = 0; i < store.state.devicelist.length; i++) if (store.state.devicelist[i].selected) selectedMenu.push(store.state.devicelist[i].no)
    console.log('## ' + selectedMenu)

    api.fetchMenuRanking(selectedMenu, store.state.period.startdate, store.state.period.enddate , store.state.period.desc)
      .then((response) => {
          if (response.data.status === 'success') {
            store.state.ranks = response.data.result.diet_list
            console.log('## result : ' + JSON.stringify(store.state.ranks))
          } else if(response.data.status === 'logout') {
            alert('에러 : ' + response.data.message)
            api.goLogin()
          } else {
            alert('에러 : ' + response.data.message)
          }
        })
  },

  [Constant.FETCH_MENUS]: (store, payload) => {
    console.log('## action [Constant.FETCH_MENUS]:(store) ' + payload.no)
    api.fetchDeviceOne(payload.no)
      .then((response) => {
        if (response.data.status === 'success') {
          // store.dispatch(Constant.ADD_DEVICE);//, {pageno: 1})
          console.log('연락처 조회 성공 : ' + response.data)

          store.commit(Constant.FETCH_DEVICE_ONE, response.data.result)

          /*
          var obj = new Object();
          obj.no = response.data.no;
          obj.name = response.data.name;
          obj.serial = response.data.serial;
          //obj.dailysame = response.data.;
          obj.dailysetting = '';
          obj.weeklysettings = '';
          */
        } else if(response.data.status === 'logout') {
          alert('에러 : ' + response.data.message)
          api.goLogin()
        } else {
          alert('에러 : ' + response.data.message)
        }
      })
  },

  [Constant.FETCH_DEVICE_ONE]: (store, payload) => {
    console.log('## action [Constant.FETCH_DEVICE_ONE]:(store) ' + payload.no)
    api.fetchDeviceOne(payload.no)
      .then((response) => {
        if (response.data.status === 'success') {
          // store.dispatch(Constant.ADD_DEVICE);//, {pageno: 1})
          console.log('연락처 조회 성공 : ' + response.data)

          store.commit(Constant.FETCH_DEVICE_ONE, response.data.result)

          /*
          var obj = new Object();
          obj.no = response.data.no;
          obj.name = response.data.name;
          obj.serial = response.data.serial;
          //obj.dailysame = response.data.;
          obj.dailysetting = '';
          obj.weeklysettings = '';
          */
        } else if(response.data.status === 'logout') {
          alert('에러 : ' + response.data.message)
          api.goLogin()
        } else {
          alert('에러 : ' + response.data.message)
        }
      })
  },

  [Constant.UPDATE_PHOTO]: (store, payload) => {
    console.log('## Constant.UPDATE_PHOTO')
    // store.commit(Constant.CANCEL_FORM);
    var currentPageNo = store.state.contactlist.pageno
    api.updatePhoto(payload.no, payload.file)
      .then((response) => {
        store.dispatch(Constant.CANCEL_FORM)
        store.dispatch(Constant.FETCH_CONTACTS, {pageno: currentPageNo})
      })
  },

  [Constant.FETCH_CONTACTS]: (store, payload) => {
    var pageno
    if (typeof payload === 'undefined' || typeof payload.pageno === 'undefined') { pageno = 1 } else { pageno = payload.pageno }
    var pagesize = store.state.contactlist.pagesize

    store.dispatch(Constant.CHANGE_IS_LOADING, {isloading: true})
    api.fetchContacts(pageno, pagesize).then((response) => {
      store.commit(Constant.FETCH_CONTACTS, {contactlist: response.data})
      store.dispatch(Constant.CHANGE_IS_LOADING, {isloading: false})
    })
  },

  [Constant.FETCH_CONTACT_ONE]: (store, payload) => {
    api.fetchContactOne(payload.no).then((response) => {
      store.commit(Constant.FETCH_CONTACT_ONE, {contact: response.data})
    })
  },

  [Constant.INITIALIZE_CONTACT_ONE]: (store) => {
    store.commit(Constant.INITIALIZE_CONTACT_ONE)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js